<template>
  <div id="insurance-pay">
    <!-- 面包屑导航 -->
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/insurances'">保险商城</router-link>
      <div class="bread-arrow">&gt;</div>
      <div class="bread-item bread-ellipsis">{{insuranceData.product_name}}</div>
      <div class="bread-arrow">&gt;</div>
      <div class="bread-item bread-ellipsis">确认订单</div>
    </div>

    <div class="insurance-page">
      <!-- 保险信息 -->
      <div class="insurance-info" v-if="insuranceData.product_name">
        <div class="info-title">{{insuranceData.product_name}}-{{insuranceData.plan_name}}</div>

        <div class="info-content">
          <div class="info-content-item" v-if="insuranceData.insurant_age">
            <div class="item-content-title">承保年龄</div>
            <div class="content-info">{{insuranceData.insurant_age}}</div>
          </div>
          <div class="info-content-item">
            <div class="item-content-title">起保日期</div>
            <div class="content-info">{{moment(insuranceData.start_date).format('YYYY年M月D日')}}</div>
          </div>
          <div class="info-content-item">
            <div class="item-content-title">保障天数</div>
            <div class="content-info">{{insuranceData.protect_days}}</div>
          </div>
          <div class="info-content-item" v-if="insuranceData.destination">
            <div class="item-content-title">旅行目的地</div>
            <div class="content-info">{{insuranceData.destination}}</div>
          </div>
          <div class="info-content-item" v-if="insuranceData.travel_delays !== undefined">
            <div class="item-content-title">旅行延误升级</div>
            <div class="content-info">{{insuranceData.travel_delays ? '是':'否'}}</div>
          </div>
          <div class="info-content-item email">
            <div class="item-content-title">电子邮箱</div>
            <div class="content-info">{{insuranceData.email}}</div>
          </div>
        </div>
        <div class="insurance-update" @click="updateInsurance">修改信息</div>
      </div>

      <!-- 投保人信息 企业，指定投保企业 -->
      <div class="insurance-policyholder" v-if="currentInsuranceTypeIsCompany && insuranceData.for_who === 1" >
        <div class="title">投保人信息</div>
        <div class="content">
          <div class="policyholder-info">
            <div class="policyholder-item">
              <div class="item-content-title">企业名称</div>
              <div class="bg-info">{{insuranceData.applicant.cname}}</div>
            </div>
            <div class="policyholder-item f-s-1">
              <div class="item-content-title">企业名称拼音</div>
              <div class="bg-info">{{insuranceData.applicant.ename}}</div>
            </div>
            <div class="policyholder-item">
              <div class="item-content-title">{{supportCompanyStructureCode ? '组织机构代码' : '统一社会信用代码'}}</div>
              <div class="bg-info">{{insuranceData.applicant.card_code}}</div>
            </div>
            <div class="policyholder-item">
              <div class="item-content-title">手机号码</div>
              <div class="bg-info">{{insuranceData.applicant.mobile}}</div>
            </div>
          </div>

        </div>
      </div>

      <!-- 投保人信息 个人 -->
      <div class="insurance-policyholder" v-if="currentInsuranceTypeIsPersonal">
        <div class="title">投保人信息</div>
        <div class="content" v-if="!insuranceData.is_self_insure">
          <div class="policyholder-info">
            <div class="policyholder-item">
              <div class="item-content-title">姓名</div>
              <div class="bg-info">{{insuranceData.applicant.cname}}</div>
            </div>
            <div class="policyholder-item f-s-1">
              <div class="item-content-title">姓名拼音</div>
              <div class="bg-info">{{insuranceData.applicant.ename}}</div>
            </div>
            <div class="policyholder-item">
              <div class="item-content-title">证件类型</div>
              <div class="bg-info">{{insuranceData.applicant.card_type === 1 ? '身份证' : '护照'}}</div>
            </div>

            <div class="policyholder-item">
              <div class="item-content-title">证件号码</div>
              <div class="bg-info">{{insuranceData.applicant.card_code}}</div>
            </div>
            <div class="policyholder-item">
              <div class="item-content-title">出生日期</div>
              <div class="bg-info">{{insuranceData.applicant.birthday}}</div>
            </div>
            <div class="policyholder-item">
              <div class="item-content-title">性别</div>
              <div class="bg-info">{{insuranceData.applicant.sex ? '男':'女'}}</div>
            </div>
            <div class="policyholder-item">
              <div class="item-content-title">手机号码</div>
              <div class="bg-info">{{insuranceData.applicant.mobile}}</div>
            </div>
          </div>

        </div>
        <div class="self-content" v-else>
          <div class="applicant-info">
            <div class="lable">被保人本人投保</div>
            <div class="applicant-list">
              <div class="applicant-item" v-for="(ins, index) in insuranceData.insurants" :key="index">
                {{ ins.cname }}
              </div>
            </div>
          </div>
          <div class="phone-info">
            <div class="lable">手机号码</div>
            <div class="value">
              {{ insuranceData.mobile_phone }}
             </div>
          </div>
        </div>
      </div>

      <!-- 被保人信息 -->
      <div class="insurance-recognizee" v-if="insuranceData.insurants">
        <div class="header">
          <div class="title">被保人信息</div>
          <div class="expand-box" :class="{'is-expand': expandRecognizee}" v-if="insuranceData.insurants.length > 2" @click="expandRecognizee = !expandRecognizee">
            <span v-if="!expandRecognizee">展开全部({{insuranceData.insurants.length}}人)</span>
            <span v-else>收起</span>
            <img src="../../../assets/imgs/insurance-new/icon-down-gray.png" class="down-icon" alt="">
          </div>
        </div>
        <div class="content">

          <div class="recognizee-box" v-for="(ins, index) in (expandRecognizee ? insuranceData.insurants : insuranceData.insurants.slice(0, 2))" :key="index">
            <div class="recognizee-title">被保人{{index + 1}}</div>

            <div class="recognizee-content">
              <div class="recognizee-item">
                <div class="item-title">姓名</div>
                <div class="item-info">{{ins.cname}}</div>
              </div>
              <div class="recognizee-item">
                <div class="item-title">证件类型</div>
                <div class="item-info">{{ins.card_type === 1 ? '身份证' : '护照'}}</div>
              </div>
              <div class="recognizee-item">
                <div class="item-title">姓名拼音</div>
                <div class="item-info">{{ins.ename}}</div>
              </div>
              <div class="recognizee-item">
                <div class="item-title">证件号码</div>
                <div class="item-info">{{ins.card_code}}</div>
              </div>
              <div class="recognizee-item">
                <div class="item-title">出生日期</div>
                <div class="item-info">{{ins.birthday}}</div>
              </div>
              <div class="recognizee-item">
                <div class="item-title">性别</div>
                <div class="item-info">{{ins.sex ? '男':'女'}}</div>
              </div>
              <div class="recognizee-item" v-if="ins.job">
                <div class="item-title">职业</div>
                <div class="item-info">{{ins.job}}</div>
              </div>
              <div class="recognizee-item" v-if="currentInsuranceTypeIsPersonal">
                <div class="item-title">与投保人关系</div>
                <div class="item-info">{{insurantRelationMap[ins.relation_id]}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <!-- 余额信息 -->
        <div class="insurance-balance">
          <div class="balance-icon"></div>
          <div class="balance-label">可用余额</div>
          <div class="balance-value">¥ {{insuranceData.balance_amount | price}}</div>
          <div class="recharge-btn" @click="showRechargeDialog">充值</div>
        </div>

        <!-- 支付按钮 -->
        <div class="insurance-button" v-if="insuranceData.insurants">
          <div class="button-balance">
            <div class="balance-label">应付</div>
            <div class="balance-price">
              ¥ <span>{{insuranceData.single_price * insuranceData.insurants.length | price}}</span>
            </div>
          </div>
          <el-button class="pay-btn" type="primary" @click="submitPay">立即支付</el-button>
        </div>
      </div>
    </div>

    <!-- 余额不足弹窗 -->
    <el-dialog title="余额不足" v-model="rechargeTipsDialog" custom-class="recharge-tips-dialog" >
      <span>您的账户余额不足以支付此订单费用，请先充值</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="recharge-btn" type="primary" @click="showRechargeDialog" >立即充值</el-button>
      </span>
    </el-dialog>

    <recharge-dialog v-model="rechargeDialog" @recharge-success="rechargeSuccess" from="insurancePay">
    </recharge-dialog>

  </div>
</template>

<script>
import moment from 'moment';
import sensorsdata from 'sa-sdk-javascript';
import utils from '../../../libs/utils';

import insuranceApi from '../../../api/insurance-api';
import insuranceOrderNav from '../../../components/insurance-order-nav';
import rechargeDialog from '../../../components/common/recharge-dialog';
import User from '../../../libs/user.js';
import { insurantRelationMap } from '../consts/maps';
import { env } from '../../../libs/env';

export default {
  name: 'insurancePay',
  data() {
    return {
      insurantRelationMap,
      insuranceId: +this.$route.query.insuranceId,
      insuranceData: {},
      rechargeTipsDialog: false,
      rechargeDialog: false,
      expandRecognizee: false,
    };
  },
  components: {
    insuranceOrderNav,
    rechargeDialog,
  },
  computed: {
    // 投保人为公司，支持的证件类型
    supportCompanyStructureCode() {
      // 10组织机构代码证 14统一信用代码证
      return this.insuranceData.policy_holder_type_set && this.insuranceData.policy_holder_type_set.includes(10);
    },
    // 当前选中的投保类型
    currentInsuranceTypeIsCompany() {
      // 投保类型 0个人 1公司
      return this.insuranceData && this.insuranceData.insurance_type_id === 1;
    },
    currentInsuranceTypeIsPersonal() {
      // 投保类型 0个人 1公司
      return this.insuranceData && this.insuranceData.insurance_type_id === 0;
    }, 
  },
  methods: {
    moment,
    getData() {
      return insuranceApi.insuranceOrderQuery({ insurance_id: this.insuranceId }).then((data) => {
        this.insuranceData = utils.extend({}, this.insuranceData, data);
      });
    },
    // 修改更新保险订单信息
    updateInsurance() {
      const { insurance_num } = this.insuranceData;
      this.$router.push({ name: 'insuranceInfo',
        query: {
          insuranceId: this.insuranceId,
          // insuranceNum: insurance_num,
        } });
    },
    formatParam: utils.formatParam,
    // 保险支付
    insurancePayAction() {
      const loadingIns = this.$loading();
      this.payDialog = false;
      insuranceApi.insuranceOrderPay({ insurance_id: this.insuranceId }).then((data) => {
        loadingIns.close();
        const { email, case_code, product_name, single_price, insurants, insurance_num } = this.insuranceData;
        sensorsdata.track('Insurance_order_successful_payment', {
          insurance_pay_amount: single_price * insurants.length / 100,
          page_from: '保险商城',
          insurance_type: '商城保险',
          user_order_id: this.insuranceId,
        });
        // 开发环境的测试代码，手动调用更新状态 到时候上线前最好删了
        if (env === 2) {
          const url = 'https://devapi.666visa.cn/www/open/qixin_cps_callback';
          insuranceApi.paySuccessCallBack(url).then((res) => {
            insuranceApi.paySuccessCallBackAgain(insurance_num, url).then((r) => {
            }).catch((e) => {
              console.error('保险第二次回调失败');
            });
          }).catch(() => {
            console.error('保险第一次回调失败');
          });
        }
        this.$router.push({ name: 'insuranceSuccess',
          query: {
            case_code,
            product_name,
            email,
            insuranceUrl: data.insure_detail,
          } });
      }).catch((error) => {
        loadingIns.close();
        this.getData();
        if (error.ret === -1 && error.msg.indexOf('重复购买') > -1) {
          utils.msgbox.confirm(error.msg, '出错啦！', {
            confirmButtonText: '知道了',
            showCancelButton: false,
            type: 'error',
          });
        }
      });
    },
    // 打开支付弹窗
    submitPay() {
      const { balance_amount, single_price, insurants } = this.insuranceData;
      if (balance_amount < (single_price * insurants.length)) {
        // 余额不够
        this.rechargeTipsDialog = true;
        return;
      }
      this.insurancePayAction();
    },
    showRechargeDialog() {
      this.rechargeTipsDialog = false;
      this.rechargeDialog = true;
    },
    rechargeSuccess() {
      this.rechargeDialog = false;
      this.getData();
    },
  },
  created() {
    const loadingIns = this.$loading();
    this.getData().then(() => {
      loadingIns.close();
    }).catch(() => {
      loadingIns.close();
    });
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";

#insurance-pay {
  width: 1120px;
  margin: 0 auto 90px;


  .insurance-page{
    background-color: #fff;
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
    padding-top: 20px;
  }

  .insurance-info {
    background-color: @white;
    padding: 0 24px;
    border-radius: 4px;
    margin-bottom: 20px;
    position: relative;
    .info-title {
      padding-right: 90px;
      font-size: 20px;
      line-height: 32px;
      color: #2F333D;
      font-weight: 600;
      margin-bottom: 12px;
      position: relative;
      z-index: 1;
      &::after{
        content: "";
        position: absolute;
        left: 0;
        top: 23px;
        width:82px;
        height:7px;
        background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.6) 100%);
        z-index: -1;
      }
    }
    .info-content {
      box-shadow:0px 4px 8px 0px rgba(47,51,61,0.08);
      background-color: #fff;
      display: flex;
      .info-content-item{
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        padding: 16px 60px 14px 20px;
        line-height: 1;
        position: relative;
        &::after{
          content: "";
          height: 36px;
          width: 1px;
          background: #E9EEF2;
          position: absolute;
          right: 0;
          top: 16px;
        }
        &:last-child{
          border-right: none;
          flex-grow: 1;
          overflow: hidden;
        }
        .item-content-title{
          color: #91999F;
          font-size: 12px;
          margin-bottom: 8px;
        }
        .content-info{
          color: #2F333D;
          font-size: 14px;
          line-height: 18px;
          white-space: nowrap;
        }
        &.email{
          flex-shrink: 1;
          .content-info{
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
          }
        }
      }
    }
    .insurance-update {
      position: absolute;
      right: 24px;
      top: 10px;
      z-index: 3;
      cursor: pointer;
      font-size: 14px;
      color: #2F333D;
      display: flex;
      align-items: center;
      line-height: 1;
      &::before{
        content: "";
        width: 14px;
        height: 14px;
        background: url(../../../assets/imgs/insurance-new/icon-edit.png) no-repeat center / 100% 100%;
        margin-right: 4px;
      }
    }
  }

  .insurance-policyholder {
    background-color: @white;
    padding: 0 24px;
    margin-bottom: 20px;
    position: relative;
    .title{
      font-size: 20px;
      line-height: 32px;
      color: #2F333D;
      font-weight: 600;
      margin-bottom: 12px;
      position: relative;
      z-index: 1;
      &::after{
        content: "";
        position: absolute;
        left: 0;
        top: 23px;
        width:82px;
        height:7px;
        background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.6) 100%);
        z-index: -1;
      }
    }
    .content {
      .policyholder-info{
        display: flex;
        border: 1px solid #E9EEF2;
      }
      .policyholder-item {
        flex-grow: 1;
        flex-shrink: 0;
        max-width: 30%;
        display: inline-flex;
        flex-direction: column;
        font-size: 14px;
        color: #2F333D;
        &.f-s-1{
          flex-shrink: 1;
        }
        .item-content-title {
          height: 40px;
          padding: 0 12px;
          display: flex;
          align-items: center;
          background-color: #FAFBFC;
          color: #91999F;
        }
        .bg-info {
          flex-grow: 1;
          display: flex;
          align-items: center;
          padding: 8px 12px;
          line-height: 18px;
          word-break: break-all;
        }
      }
    }
    .self-content {
      .applicant-info {
        .lable{
          font-size: 12px;
          color: #91999F;
          line-height: 12px;
          margin-bottom: 10px;
        }
        .applicant-list {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: -16px;
          .applicant-item {
            padding: 7px 46px;
            background: #FAFBFC;
            border-radius: 2px;
            border: 1px solid #DEE2E6;
            font-size: 14px;
            color: #2F333D;
            line-height: 1;
            margin: 0 16px 16px 0;
          }
        }
      }
      .phone-info {
        margin-top: 20px;
        .lable {
          font-size: 12px;
          color: #91999F;
          line-height: 12px;
          margin-bottom: 10px;
        }
        .value {
          font-size: 14px;
          color: #2F333D;
          line-height: 14px;
        }
      }
    }
  }

  .insurance-recognizee {
    background-color: @white;
    padding: 0 24px;
    margin-bottom: 20px;
    position: relative;
    .header{
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .title{
        flex-grow: 1;
        font-size: 20px;
        line-height: 32px;
        color: #2F333D;
        font-weight: 600;
        position: relative;
        z-index: 1;
        &::after{
          content: "";
          position: absolute;
          left: 0;
          top: 23px;
          width:82px;
          height:7px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.6) 100%);
          z-index: -1;
        }
      }
      .expand-box{
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #2F333D;
        &.is-expand{
          .down-icon{
            transform: rotate(180deg);
          }
        }
        .down-icon{
          width: 12px;
          height: 12px;
          margin-left: 4px;
          transition: all 0.15s;
        }
      }
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      margin-right: -20px;
      .recognizee-box {
        flex-shrink: 0;
        width: 526px;
        border-radius: 4px;
        border: 1px solid #E9EEF2;
        margin-bottom: 20px;
        margin-right: 20px;
        position: relative;
        .recognizee-title {
          height: 40px;
          line-height: 40px;
          background-color: #F2F7FF;
          padding-left: 16px;
          font-size: 14px;
          color: #2F333D;
        }
        .recognizee-content{
          display: flex;
          flex-wrap: wrap;
          padding: 20px 16px;
          margin-bottom: -20px;
          .recognizee-item {
            width: 50%;
            flex-shrink: 0;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            .item-title {
              color: #91999F;
              font-size: 14px;
              margin-right: 12px;
              flex-shrink: 0;
              width: 60px;
            }
            .item-info {
              flex-grow: 1;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              color: #2F333D;
              font-size: 14px;
              padding-right: 12px;
            }
          }
        }

      }
    }

  }
  .footer{
    height: 82px;
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
    padding: 16px 16px 16px 24px;
    display: flex;
    justify-content: space-between;
    .insurance-balance{
      border: 1px solid rgba(89,159,255,0.2);
      background:rgba(89,159,255,0.04);
      border-radius:2px;
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 16px;
      .balance-icon{
        width: 32px;
        height: 26px;
        background: url(../../../assets/imgs/insurance-new/icon-pay.png) no-repeat center / 100% 100%;
        margin-right: 8px;
      }
      .balance-label{
        color: #91999F;
        font-size: 14px;
        margin-right: 8px;
      }
      .balance-value{
        color: #2F333D;
        font-size: 16px;
        font-weight: 600;
        margin-right: 20px;
      }
      .recharge-btn{
        height: 100%;
        padding: 0 20px;
        color: #599FFF;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        &::before{
          content: "";
          width: 1px;
          height: 16px;
          background:rgba(89,159,255,0.2);
          border-radius:1px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        &::after{
          content: "";
          width: 12px;
          height: 12px;
          background: url(../../../assets/imgs/insurance-new/icon-right-blue.png) no-repeat center / 100% 100%;
          margin-left: 4px;
        }
      }
    }
    .insurance-button{
      display: flex;
      align-items: center;
      .button-balance{
        display: flex;
        align-items: baseline;
        line-height: 1;
        margin-right: 24px;
        .balance-label{
          color: #2F333D;
          font-size: 14px;
          margin-right: 8px;
        }
        .balance-price{
          color: #FF8033;
          font-weight: 600;
          font-size: 20px;
          span{
            font-size: 28px;
          }
        }
      }
      .pay-btn{
        width: 200px;
        height: 50px;
        border-radius:2px;
        background: #FF8033;
        color: #fff;
        font-size: 16px;
        border: none;
      }
    }
  }

}
</style>
<style lang="less">
#insurance-pay {
  .insurance-button {
    .el-button {
      width: 240px;
      height: 40px;
    }
  }

  .pay-dialog{
    width:480px;
    text-align:center;
    border-radius:5px;

    .el-dialog__header{
      padding-top:48px;
    }

    .el-dialog__title{
      font-size:22px;
      color:#333;
      font-weight:300;
    }

    .el-dialog__body{
      font-size:18px;
      padding: 38px 20px;
      line-height: 1.5;
    }

    .el-dialog__footer{
      text-align:center;
      padding-bottom:38px;

      .el-button{
        width:150px;
        font-size:16px;

        &+.el-button{
          margin-left:22px;
        }
      }
    }
  }

  .recharge-tips-dialog{
    width: 440px;
    .el-dialog__header{
      padding: 0;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
      border-bottom: 1px solid #E9EEF2;
      position: relative;
      .el-dialog__headerbtn{
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 0;
        .el-dialog__close{
          color: #91999F;
          font-size: 14px;
        }

      }
    }
    .el-dialog__body{
      padding: 32px 64px;
      color: #2F333D;
      font-size: 18px;
      line-height: 30px;
      text-align: center;
    }
    .el-dialog__footer{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0 32px 0;
      .recharge-btn{
        width:180px;
        height:48px;
        border-radius:4px;
        background: #599FFF;
        color: #fff;
        font-size: 18px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/InsurancePay.vue